<template>
  <div class="py-2">
    <v-toolbar flat color="white">
      <b>MCA Information</b>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="mcaRows"
      class="elevation-1"
      pagination.sync="25"
      :rows-per-page-items="[{'text':'All','value':-1},5,10,25]"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr :style="getStyles(props.item.status)">
        <td
          @click="editItem(props.item)"
          class="text-xs-center"
          style="padding-left: 5px;"
        >{{ getBankName(props.item.bank_account_id) }}</td>
        <td
          @click="editItem(props.item)"
          class="text-xs-center"
        >${{ formatPrice(props.item.mca_daily_payment)}}
        </td>
        <td
          @click="editItem(props.item)"
          class="text-xs-center"
        >${{ formatPrice(props.item.mca_weekly_payment) }}
        </td>
        <td @click="editItem(props.item)" class="text-xs-center">
          <span v-if="props.item.mca_balance != '0'">${{ formatPrice(props.item.mca_balance) }}</span>
        </td>
        <td @click="editItem(props.item)" class="text-xs-center">
          <span
            v-if="props.item.mca_original_funding_amount != '0'"
          >${{ formatPrice(props.item.mca_original_funding_amount) }}</span>
        </td>
        <td @click="editItem(props.item)" class="text-xs-center">
          <b>{{ props.item.with_hold }}%</b>
        </td>
        <td
          @click="editItem(props.item)"
          class="text-xs-center"
        >{{ props.item.lender_name }}</td>
        
        <td class="text-xs-left">
          {{props.item.status}}
        </td>
        <td @click="editItem(props.item)" class="text-xs-center">{{ props.item.mca_date }}</td>
        <td class="text-xs-center" v-if="props.item.description!=  null && props.item.description.includes('MID: ')">
          <a style="width: 150px; background:#ffeb00;" :href="props.item.previous_deal_url" target="_blank">{{props.item.description}}</a>
        </td>
        <td class="text-xs-center" v-else>

          <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" style="
                width: 150px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                background:#ffeb00;
                "
                class="custom-scrollbar">
                {{props.item.description}}
                </div>
              </template>
              <span >{{props.item.description}}</span>
            </v-tooltip>
        </td>
        </tr>
      </template>
      <template slot="footer">
        <tr style="height:25px;">
          <td class="font-weight-bold text-xs-center">Totals:</td>
          <td
            class="font-weight-bold text-xs-center"
          >${{ formatPrice(caculateTotalSum.mca_daily_payment) }}</td>
          <td
            class="font-weight-bold text-xs-center"
          >${{ formatPrice(caculateTotalSum.mca_weekly_payment) }}</td>
          <td
            class="font-weight-bold text-xs-center"
          >${{ formatPrice(caculateTotalSum.mca_balance)}}</td>
          <td
            class="font-weight-bold text-xs-center"
          >${{ formatPrice(caculateTotalSum.mca_original_funding_amount)}}</td>
          <td class="font-weight-bold text-xs-center">{{formatPrice(caculateTotalSum.total_with_hold)}}%
          <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on">info</v-icon>
              </template>
              <span>Total withhold includes active pulling MCA/s only.</span>
            </v-tooltip></td>
          <!-- <td class="font-weight-bold text-xs-center">{{formatPrice(caculateTotalSum.total_with_hold_weekly)}}%</td> -->
          <td class="font-weight-bold text-xs-center">-</td>
          <td class="font-weight-bold text-xs-center">-</td>
          <td class="font-weight-bold text-xs-center">-</td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import fcs_helper from '../../helpers/fcs_helper'

export default {
  mixins: [fcs_helper],
  data: () => ({
     headers: [
      {
        text: "Bank Account",
        align: "center",
        sortable: false,
        value: "bank_account_id"
      },
      { text: "Daily Payment", value: "mca_daily_payment", align: "center" },
      { text: "Weekly Payment", value: "mca_weekly_payment", align: "center" },
      { text: "Balance", value: "mca_balance", align: "center" },
      {
        text: "Original Funding Amt",
        value: "mca_original_funding_amount",
        align: "center"
      },
      { text: "Withhold", value: "mca_withold", align: "center" },
      { text: "Lender", value: "lender_id", align: "center" },
      { text: "Status", value: "status", sortable: false, },
      { text: "Funded Date", value: "mca_date", align: "center" },
      { text: "Description", value: "description", align: "center" }
    ],
  }),
 
  methods: {
    getStyles(item){
      return (item=='paying off' || item == 'paid off') ? {'background-color': 'gainsboro'} : {}
    },
    getBankName(bank_id) {
      let name = _.filter(this.bankAccounts, o=> o.id == bank_id)
      return (name && name.length>0) ? name[0].bank_account_name : ''
    }
  }
};
</script>
<style scoped>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  height: 25px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  line-height: 1;
  font-size: 14px;
}
.vue-numeric {
  border-bottom: 1px solid grey;
  width: 100%;
  padding-bottom: 6px;
}
.effect1:focus {
  color: red;
}

.fcsToolbar {
  background-color: #fff !important;
  box-shadow: none !important;
}

.ihftToolbar {
  height: 23.33px !important; 
  box-shadow: none !important;
  background-color: #d3d3d3 !important;
}

.fcsToolbarTitle {
  font-size: 20px !important;
  font-weight: 500 !important;
  letter-spacing: .02em !important;
}
.ihftToolbarTitle {
  color: #000 !important;
  font-size: 14px !important;
  margin-left: 15px !important;
}
</style>

<style>
#fcs-toolbar .v-toolbar__content {
    height: 48px !important;
}

#ihft-toolbar .v-toolbar__content {
    height: 25px !important;
}

#fcs-mca-info-table .v-table__overflow {
    overflow-x: auto !important;
}
</style>
